import React, { useState } from 'react';
import { Dialog, DialogContent, Grid, Box, Typography, FormGroup, FormControl, FormLabel, OutlinedInput, Select, MenuItem, Button } from '@material-ui/core';
import ProviderAPI from 'config/api/ProviderAPI';
import { NotificationManager } from 'react-notifications';

function RequestCallModal({ showCallDialog, setShowCallDialog, companyDetails }) {
    const api = new ProviderAPI();
    
    const [dayOfWeek, setDayOfWeek] = useState('');
    const [timeOfDay, setTimeOfDay] = useState('');
    const [note, setNote] = useState('');
    const [loading, setLoading] = useState(false);

    async function handleRequestCall() {
        if (!dayOfWeek || !timeOfDay) {
            NotificationManager.warning('Please select a day and a time');
            return;
        }

        setLoading(true);
        try {
            await api.requestCall(companyDetails.companyId, dayOfWeek, timeOfDay, note);
            NotificationManager.success('Request submitted');
            setShowCallDialog(false);
        } catch (error) {
            NotificationManager.error('Error submitting request');
        }
        setLoading(false);
    }

    return (
        <Dialog open={showCallDialog} onClose={() => setShowCallDialog(false)} fullWidth maxWidth='sm'>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12} style={{ marginBottom: '1rem' }}>
                        <Box component={Typography} variant='h3'>
                            <Box component='span'>Request a Call</Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormGroup>
                            <FormLabel>Day of the Week</FormLabel>
                            <FormControl
                                variant='filled'
                                component={Box}
                                width='100%'
                            >
                                <Select
                                    multiple={false}
                                    value={dayOfWeek}
                                    onChange={(e) => setDayOfWeek(e.target.value)}
                                    input={<OutlinedInput />}
                                    style={{marginBottom: '0.5rem'}}
                                >
                                    <MenuItem value='Monday'>Monday</MenuItem>
                                    <MenuItem value='Tuesday'>Tuesday</MenuItem>
                                    <MenuItem value='Wednesday'>Wednesday</MenuItem>
                                    <MenuItem value='Thursday'>Thursday</MenuItem>
                                    <MenuItem value='Friday'>Friday</MenuItem>
                                </Select>
                            </FormControl>
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormGroup>
                            <FormLabel>Time of the Day</FormLabel>
                            <FormControl
                                variant='filled'
                                component={Box}
                                width='100%'
                            >
                                <Select
                                    multiple={false}
                                    value={timeOfDay}
                                    onChange={(e) => setTimeOfDay(e.target.value)}
                                    input={<OutlinedInput />}
                                    style={{marginBottom: '0.5rem'}}
                                >
                                    <MenuItem value='Morning'>Morning</MenuItem>
                                    <MenuItem value='Afternoon'>Afternoon</MenuItem>
                                    <MenuItem value='Evening'>Evening</MenuItem>
                                </Select>
                            </FormControl>
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12}>
                        <FormGroup>
                            <FormLabel>Note (Optional)</FormLabel>
                            <OutlinedInput
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                                fullWidth
                                placeholder='Add any additional details here...'
                                multiline
                                rows={4}
                            />
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12}>
                        <Box display='flex' justifyContent='space-between' p={2}>
                            <Button color='primary' variant='outlined' onClick={() => setShowCallDialog(false)} style={{ marginRight: '1rem' }}>Cancel</Button>
                            <Button color='primary' variant='contained' onClick={handleRequestCall} disabled={loading || !dayOfWeek || !timeOfDay}>Request Call</Button>
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}

export default RequestCallModal;